import React from 'react';
import ExcelImportExport from '../compartidos/ExcelImportExport';
import ModalAgregarSubcontrato from './ModalAgregarSubcontrato';
import ModalEditarSubcontrato from './ModalEditarSubcontrato';

function TabMatrizSubcontrato({
  tasks, materiales, sections, materialSections, teamMembers,
  showConfigDays, setShowConfigDays,
  showTaskForm, setShowTaskForm,
  filtrosBusqueda, setFiltrosBusqueda,
  processDays, setProcessDays,
  handleSaveProcessDays, savingConfig,
  specialty, setSpecialty,
  taskText, setTaskText, dueDate, setDueDate,
  addTask,
  modoDesdePrograma, setModoDesdePrograma,
  actividadesSubcontrato, setActividadesSubcontrato,
  partidaPrograma, setPartidaPrograma,
  actMapPrograma, setActMapPrograma,
  obtenerActividadesKpi,
  nombresPlantillas, cargarNombresPlantillas,
  mostrarSugerenciasSubcontrato, setMostrarSugerenciasSubcontrato,
  subcontratosFiltrados, renderTableRows,
  handleImportComplete,
  allTasksSelected, selectAllTasks, clearAllTaskSelection,
  editTaskId, editFields, setEditFields,
  editTaskModoPrograma, setEditTaskModoPrograma,
  saveEditTask, cancelEditTask
}) {
  return (
    <div className="tab-content matriz-subcontrato-page">
      <section className="progress-section-v2">
        {/* Header */}
        <div className="critical-header-bar">
          <h2 className="matriz-page-title">Subcontratos</h2>
        </div>

        {/* Botones de acción */}
        <div className="team-actions-row">
          <button 
            className={`team-action-btn ${showConfigDays ? 'active-red' : 'amber'}`}
            onClick={() => setShowConfigDays(v => !v)}
          >
            {showConfigDays ? 'Ocultar Config.' : 'Configurar Días'}
          </button>
          <button 
            className={`team-action-btn ${showTaskForm ? 'active-red' : 'green'}`}
            onClick={() => setShowTaskForm(v => !v)}
          >
            {showTaskForm ? 'Ocultar Formulario' : '+ Agregar Subcontrato'}
          </button>
          <ExcelImportExport
            tasks={tasks}
            materiales={materiales}
            sections={sections}
            materialSections={materialSections}
            teamMembers={teamMembers}
            onImportComplete={handleImportComplete}
          />
        </div>
      
        {/* PANEL DE FILTROS DE SUBCONTRATOS */}
        <div className="filtros-panel-mejorado">
          <div className="filtros-grid">
            <div className="filtro-campo">
              <label className="filtro-label">Buscar</label>
              <input
                type="text"
                placeholder="Nombre de subcontrato..."
                value={filtrosBusqueda.texto}
                onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, texto: e.target.value})}
                className="filtro-input"
              />
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Especialidad</label>
              <select
                value={filtrosBusqueda.especialidad}
                onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, especialidad: e.target.value})}
                className="filtro-select"
              >
                <option value="todas">Todas las especialidades</option>
                {sections.map(section => (
                  <option key={section.id} value={section.name}>{section.name}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Responsable</label>
              <select
                value={filtrosBusqueda.responsable}
                onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, responsable: e.target.value})}
                className="filtro-select"
                style={{ borderColor: '#374151' }}
              >
                <option value="todos">Todos</option>
                <option value="sin-responsable">Sin responsable</option>
                {teamMembers.map(member => (
                  <option key={member.id} value={member.id}>{member.name}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Proceso</label>
              <select
                value={filtrosBusqueda.proceso}
                onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, proceso: e.target.value})}
                className="filtro-select"
              >
                <option value="todos">Todos los procesos</option>
                <option value="inicio">Inicio</option>
                <option value="envios">Envíos</option>
                <option value="comparativo">Comparativo</option>
                <option value="negociacion">Negociación</option>
                <option value="precalificacion">Precalificación</option>
                <option value="contratoFirmado">Contrato Firmado</option>
              </select>
            </div>
            
            <div className="filtro-campo-especial">
              <label className="filtro-checkbox-label">
                <input
                  type="checkbox"
                  checked={filtrosBusqueda.criticos}
                  onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, criticos: e.target.checked})}
                  className="filtro-checkbox"
                />
                <span className="checkbox-texto">Solo críticos (7 días)</span>
              </label>
            </div>

            <div className="filtro-campo-especial">
              <label className="filtro-checkbox-label">
                <input
                  type="checkbox"
                  checked={filtrosBusqueda.pendientes}
                  onChange={(e) => setFiltrosBusqueda({...filtrosBusqueda, pendientes: e.target.checked})}
                  className="filtro-checkbox"
                />
                <span className="checkbox-texto">Solo pendientes</span>
              </label>
            </div>

            <div className="filtro-campo-especial">
              <button
                onClick={() => setFiltrosBusqueda({ texto: '', especialidad: 'todas', criticos: false, pendientes: false, proceso: 'todos', responsable: 'todos' })}
                className="filtro-btn-limpiar"
              >
                Limpiar filtros
              </button>
            </div>
          </div>
        </div>
        
        {showConfigDays && (
          <section className="config-section">
            <h2>CONFIGURAR DÍAS POR PROCESO</h2>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '15px' }}>
              Esta configuración afectará a todos los subcontratos futuros que agregues.
            </p>
            <div className="config-inputs">
              <div>
                <label>ENVIOS (DIAS):</label>
                <input type="number" min="0" value={processDays.inicio} onChange={(e) => setProcessDays({...processDays, inicio: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>COMPARATIVO (DIAS):</label>
                <input type="number" min="0" value={processDays.envios} onChange={(e) => setProcessDays({...processDays, envios: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>NEGOCIACIÓN (DIAS):</label>
                <input type="number" min="0" value={processDays.comparativo} onChange={(e) => setProcessDays({...processDays, comparativo: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>PRE-CALIFICACIÓN (DIAS):</label>
                <input type="number" min="0" value={processDays.negociacion} onChange={(e) => setProcessDays({...processDays, negociacion: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>CONTRATO FIRMADO (DIAS):</label>
                <input type="number" min="0" value={processDays.precalificacion} onChange={(e) => setProcessDays({...processDays, precalificacion: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>INICIO DE PARTIDA (DIAS):</label>
                <input type="number" min="0" value={processDays.contratoFirmado} onChange={(e) => setProcessDays({...processDays, contratoFirmado: parseInt(e.target.value) || 0})} />
              </div>
            </div>
            <button
              onClick={handleSaveProcessDays}
              disabled={savingConfig}
              className="save-config-button"
              style={{
                marginTop: '20px',
                backgroundColor: savingConfig ? '#9ca3af' : '#374151',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: savingConfig ? 'not-allowed' : 'pointer',
                fontWeight: '600',
                fontSize: '14px',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseOver={(e) => !savingConfig && (e.target.style.backgroundColor = '#374151')}
              onMouseOut={(e) => !savingConfig && (e.target.style.backgroundColor = '#374151')}
            >
              {savingConfig ? (
                <>
                  <span style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite',
                    display: 'inline-block'
                  }}></span>
                  Guardando...
                </>
              ) : (
                <>Guardar Configuración</>
              )}
            </button>
          </section>
        )}

        {/* Formulario de Subcontratos (modal) */}
        <ModalAgregarSubcontrato
          visible={showTaskForm}
          onCerrar={() => setShowTaskForm(false)}
          sections={sections}
          specialty={specialty} setSpecialty={setSpecialty}
          taskText={taskText} setTaskText={setTaskText}
          dueDate={dueDate} setDueDate={setDueDate}
          addTask={addTask}
          modoDesdePrograma={modoDesdePrograma} setModoDesdePrograma={setModoDesdePrograma}
          actividadesSubcontrato={actividadesSubcontrato} setActividadesSubcontrato={setActividadesSubcontrato}
          partidaPrograma={partidaPrograma} setPartidaPrograma={setPartidaPrograma}
          actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
          obtenerActividadesKpi={obtenerActividadesKpi}
          nombresPlantillas={nombresPlantillas} cargarNombresPlantillas={cargarNombresPlantillas}
          mostrarSugerenciasSubcontrato={mostrarSugerenciasSubcontrato} setMostrarSugerenciasSubcontrato={setMostrarSugerenciasSubcontrato}
        />

        {/* Formulario de edición de Subcontrato (modal) */}
        <ModalEditarSubcontrato
          visible={editTaskId !== null}
          onCerrar={cancelEditTask}
          sections={sections}
          editFields={editFields} setEditFields={setEditFields}
          editTaskModoPrograma={editTaskModoPrograma} setEditTaskModoPrograma={setEditTaskModoPrograma}
          actividadesSubcontrato={actividadesSubcontrato} setActividadesSubcontrato={setActividadesSubcontrato}
          actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
          obtenerActividadesKpi={obtenerActividadesKpi}
          saveEditTask={saveEditTask}
          editTaskId={editTaskId}
        />

        {/* Contador de resultados de filtros */}
        {(filtrosBusqueda.texto || filtrosBusqueda.especialidad !== 'todas' || filtrosBusqueda.criticos || filtrosBusqueda.pendientes) && (
          <div style={{
            padding: '10px 15px',
            backgroundColor: '#f3f4f6',
            borderRadius: '6px',
            marginBottom: '12px',
            fontSize: '14px',
            color: '#374151'
          }}>
            Mostrando {subcontratosFiltrados.length} de {tasks.length} subcontratos
          </div>
        )}

        {/* Tabla de Subcontratos */}
        <div className="table-wrapper">
          <table className="tasks-table">
            <thead>
              <tr>
                <th className="checkbox-seleccion">
                  <div className="checkbox-header-container">
                    <input
                      type="checkbox"
                      className="checkbox-seleccion-input"
                      checked={allTasksSelected}
                      onChange={(e) => e.target.checked ? selectAllTasks() : clearAllTaskSelection()}
                      title={allTasksSelected ? 'Deseleccionar todos' : 'Seleccionar todos'}
                    />
                  </div>
                </th>
                <th>Responsable</th>
                <th>Subcontrato</th>
                {filtrosBusqueda.proceso === 'todos' ? (
                  <>
                    <th style={{ width: '95px' }}>Inicio</th>
                    <th style={{ width: '95px' }}>Envíos</th>
                    <th style={{ width: '95px' }}>Comparativo</th>
                    <th style={{ width: '95px' }}>Negociación</th>
                    <th style={{ width: '95px' }}>Pre-calificación</th>
                    <th style={{ width: '95px' }}>Contrato Firmado</th>
                  </>
                ) : (
                  <th>
                    {filtrosBusqueda.proceso === 'inicio' && 'Inicio'}
                    {filtrosBusqueda.proceso === 'envios' && 'Envíos'}
                    {filtrosBusqueda.proceso === 'comparativo' && 'Comparativo'}
                    {filtrosBusqueda.proceso === 'negociacion' && 'Negociación'}
                    {filtrosBusqueda.proceso === 'precalificacion' && 'Pre-calificación'}
                    {filtrosBusqueda.proceso === 'contratoFirmado' && 'Contrato Firmado'}
                  </th>
                )}
                <th>Inicio de Partida</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {tasks.length === 0 ? (
                <tr>
                  <td colSpan="13">No hay subcontratos añadidos</td>
                </tr>
              ) : (
                renderTableRows()
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default TabMatrizSubcontrato;
